import React from 'react';
import { Switch } from 'antd';
import PropTypes from 'prop-types';
import { Label, InfoMessage } from 'components';

const SwitchGroup = ({
  label,
  sublabel,
  disabled,
  bold,
  labelBold,
  asterisk = false,
  infoMessage,
  iconClassName,
  infoMessageClassName,
  value,
  onChange,
  checkedChildren,
  unCheckedChildren,
  ...rest
}) => {
  return (
    <div className="custom-switch-component">
      <div className={`d-flex ${labelBold ? 'text-bold' : ''}`}>
        <div>
          <Label label={label} bold={bold} asterisk={asterisk} />
          {sublabel && <i><Label label={sublabel} /></i>}
        </div>
        <InfoMessage
          infoMessage={infoMessage}
          overlayClassName={infoMessageClassName}
          iconClassName={iconClassName}
        />
      </div>
      <Switch
        checked={value}
        onChange={onChange}
        disabled={disabled}
        checkedChildren={checkedChildren}
        unCheckedChildren={unCheckedChildren}
        {...rest}
      />
    </div>
  );
};

SwitchGroup.propTypes = {
  label: PropTypes.string.isRequired,
  sublabel: PropTypes.string,
  disabled: PropTypes.bool,
  bold: PropTypes.bool,
  labelBold: PropTypes.bool,
  asterisk: PropTypes.bool,
  infoMessage: PropTypes.string,
  iconClassName: PropTypes.string,
  infoMessageClassName: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  checkedChildren: PropTypes.node,
  unCheckedChildren: PropTypes.node,
};

export default SwitchGroup;
